import React from "react";
import CssTransition from "../../../../component/layout/css-transition";
import { StyledDropZone } from "react-drop-zone";
import "react-drop-zone/dist/styles.css";

function UploadCSVFile({
  openModalPopup,
  setOpenModalPopup,
  handleExcelFileUpload,
  fileURL,
}) {
  return (
    <div
      onClick={(e) => {
        if (e.target.id === "modal1" || e.target.id === "modal2") {
          setOpenModalPopup(false);
        }
      }}
    >
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={openModalPopup}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
        id="modal1"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={openModalPopup}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
        id="modal2"
      >
        <div className="bg-white overflow-auto max-w-2xl w-full max-h-full rounded-2xl shadow-lg flex flex-col relative">
          <div className="py-8 px-6 space-y-5">
            <div className="space-y-2">
              <h4 className="text-base leading-5 text-[#1E293B] font-semibold text-center">
                Upload File
              </h4>
              <div className="w-full flex justify-center">
                <p className="w-3/4 text-sm text-center text-[#888888] leading-5">
                  Please upload an Excel file in the required format, you can
                  download a template file from the link below.
                </p>
              </div>
            </div>
            <a
              className="btn bg-[--bg-color-500] text-white"
              href={fileURL}
              download="Template"
            >
              <span className={`fa-light fa-arrow-down-to-line mr-2`}></span>
              DOWNLOAD TEMPLATE FILE
            </a>
            <div>
              <StyledDropZone
                accept=".xlsx"
                onDrop={(e) => handleExcelFileUpload(e)}
                children={"UPLOAD USERS FILE (.xlsx)"}
              />
            </div>
          </div>
        </div>
      </CssTransition>
    </div>
  );
}

export default UploadCSVFile;
